import React from 'react';
import { useTranslation } from 'react-i18next';
import Card from '../card/Card';

type Props = {
  renderYearSelect: () => JSX.Element;
  renderMonthSelect: () => JSX.Element;
  renderDownloadExcelBtn: () => JSX.Element | undefined;
}

const MeasuredDataHeader = ({ renderYearSelect, renderMonthSelect, renderDownloadExcelBtn }: Props) => {
  // translations
  const tLabels = useTranslation("shared\\components").t;

  return (
    <Card className="p-3 mb-4">
      <div className="row no-gutters align-items-center mx-n2 mx-sm-0">
        <div className="col-6 col-sm-auto pr-sm-3 px-2 px-sm-0">
          <div className="d-flex align-items-center">
            <span className="mr-2 text-muted">
              {tLabels("measuredDataHeader.year")}:
            </span>
            {renderYearSelect()}
          </div>
        </div>
        <div className="col-6 col-sm-auto px-2 pr-sm-3 px-sm-0">
          <div className="d-flex align-items-center">
            <span className="mr-2 text-muted">
              {tLabels("measuredDataHeader.month")}:
            </span>
            {renderMonthSelect()}
          </div>
        </div>
        <div className="col-sm-auto ml-sm-auto px-2 px-sm-0">
          {renderDownloadExcelBtn()}
        </div>
      </div>
    </Card>
  );
}

export default MeasuredDataHeader;